import { MaterialsToComplete } from '../ProjectSimulator';
import PhotovoltaicAndExploitation, {
  ExploitationData,
  PhotovoltaicData,
} from './PhotovoltaicAndExploitation';
import BuildingStructure, { BuildingStructureData } from './BuildingStructure';
import Facade, { FacadeData } from './BuildingStructure/Facade';
import { UseFormReturn } from 'react-hook-form';

type AdvancedConceptionProps = {
  advancedConception: AdvancedConceptionData;
  frameworkMaterials: MaterialsToComplete[];
  wallTypeMaterials: MaterialsToComplete[];
  ceilingMaterials: MaterialsToComplete[];
  floorMaterials: MaterialsToComplete[];
  form: UseFormReturn;
};

export type AdvancedConceptionData = {
  buildingStructure: BuildingStructureData;
  facade: FacadeData;
  photovoltaic: PhotovoltaicData;
  exploitation: ExploitationData;
};

function AdvancedConception({
  advancedConception,
  frameworkMaterials,
  wallTypeMaterials,
  ceilingMaterials,
  floorMaterials,
  form,
}: AdvancedConceptionProps) {
  return (
    <div
      style={{
        display: 'flex',
        columnGap: '32px',
      }}
    >
      <BuildingStructure
        buildingStructure={advancedConception.buildingStructure}
        frameworkMaterials={frameworkMaterials}
        wallTypeMaterials={wallTypeMaterials}
        ceilingMaterials={ceilingMaterials}
        floorMaterials={floorMaterials}
        form={form}
      />
      <Facade facade={advancedConception.facade} form={form} />
      <PhotovoltaicAndExploitation
        photovoltaic={advancedConception.photovoltaic}
        exploitation={advancedConception.exploitation}
        form={form}
      />
    </div>
  );
}

export default AdvancedConception;
